import axios from 'utils/axios';

// Ask Jivan is org-scoped and gated per org from platform admin. Any user in an
// enabled org may use it.

// Response: { enabled }
export async function getAskJivanEnabled() {
    const response = await axios.get('/api/org-id/{orgId}/ask-jivan/enabled');

    return response;
}

// Omit conversationId on the first question; the server starts the conversation.
// Response: { conversationId, userMessageId, answer: { id, role, content, citations, answeredFromDocuments, rating, createdAt } }
export async function askQuestion(conversationId, question) {
    const payload = conversationId ? { conversationId, question } : { question };
    const response = await axios.post('/api/org-id/{orgId}/ask-jivan/message', payload);

    return response;
}

// Response: { conversations: [{ id, title, createdAt, lastMessageAt }] }
export async function getRecentConversations() {
    const response = await axios.get('/api/org-id/{orgId}/ask-jivan/conversation/recent');

    return response;
}

// Response: { conversation, messages }
export async function getConversation(conversationId) {
    const response = await axios.get(`/api/org-id/{orgId}/ask-jivan/conversation/${conversationId}`);

    return response;
}

// rating: 'UP' | 'DOWN' | null (null takes a rating back)
export async function rateAnswer(messageId, rating, comment) {
    const response = await axios.post(`/api/org-id/{orgId}/ask-jivan/message/${messageId}/feedback`, {
        rating,
        comment: comment || null
    });

    return response;
}
